import React from 'react';

import { fixNullString } from '../../common/Util';
import { SelectBoxStyled } from '../../asset/styled/component/SelectBoxStyled';

export const SelectBox = ({
  label,
  labelStyle,
  children,
  style,
  value,
  selectRef,
  className,
  size = 'medium',
  options,
  ...rest
}) => {
  return (
    <SelectBoxStyled style={style} size={size}>
      {label != undefined && (
        <label htmlFor="test1" className="captionMedium selectLabel" style={labelStyle}>
          {label}
        </label>
      )}
      <div className="selectDiv">
        <select
          className={`select ${className}`}
          id="test1"
          value={fixNullString(value, '')}
          ref={selectRef}
          {...rest}>
          {options
            ? options.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))
            : children}
        </select>
      </div>
    </SelectBoxStyled>
  );
};
